export default __webpack_public_path__ + "static/media/CSIO_2020_Annual_Report_Lo.a572ee6f.pdf";